"use client"
import Select from "react-select";
import { useState, useEffect } from "react"
import axios from "axios"



const AddSale = () => {
  const [saleInfo, setSaleInfo] = useState({
    product_master_code: "",
    product_name: "",
    category_name: "",
    product_unit: "",
    product_color: "",
    quantity_sold: "",
    Date: new Date().toISOString().split('T')[0] // Set default to today's date
  })
  const [isSubmitting, setIsSubmitting] = useState(false)
  const [error, setError] = useState(null)
  const [success, setSuccess] = useState(false)
  const [categories, setCategories] = useState([])
  const [units, setUnits] = useState([])
  const [colors, setColors] = useState([])
  const [products, setProducts] = useState([])

  useEffect(() => {
    fetchCategories()
    fetchUnits()
    fetchColors()
    fetchProducts()
  }, [])

  const fetchCategories = async () => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_API_URI}/api/get-product-categories`,
        {
          headers: {
            'authorization': localStorage.getItem("accessToken"),
            'Content-Type': 'application/json'
          }
        }
      )
      if (response.data && response.data.data) {
        setCategories(response.data.data)
      } else {
        console.error("Unexpected API response format:", response.data)
        setError("Failed to fetch categories: Invalid response format")
      }
    } catch (err) {
      console.error("Error fetching categories:", err)
      setError(err.response?.data?.message || "Failed to fetch categories. Please try again.")
    }
  }

  const fetchUnits = async () => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_API_URI}/api/get-product-units`,
        {
          headers: {
            'authorization': localStorage.getItem("accessToken"),
            'Content-Type': 'application/json'
          }
        }
      )
      if (response.data && response.data.units) {
        setUnits(response.data.units)
      }
    } catch (err) {
      setError("Failed to fetch units")
    }
  }

  const fetchColors = async () => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_API_URI}/api/get-product-colors`,
        {
          headers: {
            'authorization': localStorage.getItem("accessToken"),
            'Content-Type': 'application/json'
          }
        }
      )
      if (response.data && response.data.data) {
        setColors(response.data.data)
      } else {
        console.error("Unexpected API response format:", response.data)
        setError("Failed to fetch colors: Invalid response format")
      }
    } catch (err) {
      console.error("Error fetching colors:", err)
      setError(err.response?.data?.message || "Failed to fetch colors. Please try again.")
    }
  }

  const fetchProducts = async () => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_API_URI}/api/get-products`,
        {
          headers: {
            'authorization': localStorage.getItem("accessToken"),
            'Content-Type': 'application/json'
          }
        }
      )
      if (response.data && response.data.data) {
        setProducts(response.data.data)
      } else {
        console.error("Unexpected API response format:", response.data)
        setError("Failed to fetch products: Invalid response format")
      }
    } catch (err) {
      console.error("Error fetching products:", err)
      setError(err.response?.data?.message || "Failed to fetch products. Please try again.")
    }
  }

  const handleProductSelect = (e) => {
    const selectedProduct = products.find(p => p.product_code === e.target.value)
    if (selectedProduct) {
      setSaleInfo({
        ...saleInfo,
        product_master_code: selectedProduct.product_code,
        product_name: selectedProduct.product_name,
        category_name: selectedProduct.category_name,
        product_unit: selectedProduct.product_unit
      })
    } else {
      setSaleInfo({
        ...saleInfo,
        product_master_code: "",
        product_name: "",
        category_name: "",
        product_unit: ""
      })
    }
  }

  const handleInputChange = (e) => {
    const { name, value } = e.target
    setSaleInfo(prev => ({
      ...prev,
      [name]: value
    }))
  }

  const handleSubmit = async (e) => {
    e.preventDefault()
    setIsSubmitting(true)
    setError(null)
    setSuccess(false)

    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API_URI}/api/add-sold-product`,
        saleInfo,
        {
          headers: {
            'authorization': localStorage.getItem("accessToken"),
            'Content-Type': 'application/json'
          }
        }
      )

      if (response.data) {
        setSuccess(true)
        setSaleInfo({
          product_master_code: "",
          product_name: "",
          category_name: "",
          product_unit: "",
          product_color: "",
          quantity_sold: "",
          Date: new Date().toISOString().split('T')[0]
        })
      }
    } catch (err) {
      setError(err.response?.data?.error || err.response?.data?.message || "Failed to add sale")
    } finally {
      setIsSubmitting(false)
    }
  }
const productOptions = products.map((product) => ({
  value: product.product_code,
  label: `${product.product_code} - ${product.product_name}`,
}));

const colorOptions = colors.map((color) => ({
  value: color.product_color,
  label: color.product_color,
}));
  return (
    <div className="min-h-screen bg-gray-50 p-2">
      <div className="max-w-7xl mx-auto">
        <div className="flex justify-between items-start mb-6">
          <div>
            <h1 className="text-2xl font-semibold text-gray-900 mb-1">Add Sale</h1>
            <p className="text-gray-500">Create a new sale record</p>
          </div>
        </div>

        <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-6">
          {error && (
            <div className="mb-4 p-4 bg-red-50 border border-red-200 rounded-lg text-red-600">
              {error}
            </div>
          )}
          {success && (
            <div className="mb-4 p-4 bg-green-50 border border-green-200 rounded-lg text-green-600">
              Sale added successfully!
            </div>
          )}

          <form onSubmit={handleSubmit} className="space-y-6">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  Product Code
                </label>
                {/* <select
                  name="product_master_code"
                  value={saleInfo.product_master_code}
                  onChange={handleProductSelect}
                  className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-orange-500 focus:border-orange-500 outline-none"
                  required
                >
                  <option value="">Select Product</option>
                  {products.map((product) => (
                    <option key={product.id} value={product.product_code}>
                      {product.product_code} - {product.product_name}
                    </option>
                  ))}
                </select> */}

                <Select
                  options={productOptions}
                  value={productOptions.find(
                    (option) => option.value === saleInfo.product_master_code
                  ) || null}
                  onChange={(selectedOption) => {
                    const selectedProduct = products.find(
                      (p) => p.product_code === selectedOption?.value
                    );

                    if (selectedProduct) {
                      setSaleInfo({
                        ...saleInfo,
                        product_master_code: selectedProduct.product_code,
                        product_name: selectedProduct.product_name,
                        category_name: selectedProduct.category_name,
                        product_unit: selectedProduct.product_unit
                      });
                    } else {
                      setSaleInfo({
                        ...saleInfo,
                        product_master_code: "",
                        product_name: "",
                        category_name: "",
                        product_unit: ""
                      });
                    }
                  }}
                  isDisabled={isSubmitting}
                  placeholder="Select Product"
                  isClearable={true}
                  className="w-full"
                  classNamePrefix="react-select"
                />
              </div>

              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  Product Name
                </label>
                <input
                  type="text"
                  name="product_name"
                  value={saleInfo.product_name}
                  readOnly
                  className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-orange-500 focus:border-orange-500 outline-none bg-gray-50"
                />
              </div>

              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  Category
                </label>
                <input
                  type="text"
                  name="category_name"
                  value={saleInfo.category_name}
                  readOnly
                  className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-orange-500 focus:border-orange-500 outline-none bg-gray-50"
                />
              </div>

              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  Material
                </label>
                <input
                  type="text"
                  name="product_unit"
                  value={saleInfo.product_unit}
                  readOnly
                  className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-orange-500 focus:border-orange-500 outline-none bg-gray-50"
                />
              </div>

              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  Color
                </label>
                {/* <select
                  name="product_color"
                  value={saleInfo.product_color}
                  onChange={handleInputChange}
                  className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-orange-500 focus:border-orange-500 outline-none"
                  required
                >
                  <option value="">Select Color</option>
                  {colors.map((color) => (
                    <option key={color.id} value={color.product_color}>
                      {color.product_color}
                    </option>
                  ))}
                </select> */}
                <Select
                  options={colorOptions}
                  value={colorOptions.find(
                    (option) => option.value === saleInfo.product_color
                  ) || null}
                  onChange={(selectedOption) =>
                    handleInputChange({
                      target: { name: "product_color", value: selectedOption?.value || "" }
                    })
                  }
                  isDisabled={isSubmitting}
                  placeholder="Select Color"
                  isClearable={true}
                  className="w-full"
                  classNamePrefix="react-select"
                />
              </div>

              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  Quantity
                </label>
                <input
                  type="number"
                  name="quantity_sold"
                  value={saleInfo.quantity_sold}
                  onChange={handleInputChange}
                  className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-orange-500 focus:border-orange-500 outline-none"
                  required
                  min="1"
                />
              </div>

              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  Sale Date
                </label>
                <input
                  type="date"
                  name="Date"
                  value={saleInfo.Date}
                  onChange={handleInputChange}
                  className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-orange-500 focus:border-orange-500 outline-none"
                  required
                />
              </div>
            </div>

            <div className="flex justify-end gap-4">
              <button
                type="button"
                onClick={() => window.location.href = '/sales'}
                className="px-6 py-2 border border-gray-300 rounded-lg text-gray-700 hover:bg-gray-50 transition-colors"
              >
                Cancel
              </button>
              <button
                type="submit"
                disabled={isSubmitting}
                className="px-6 py-2 bg-orange-500 text-white rounded-lg hover:bg-orange-600 transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
              >
                {isSubmitting ? "Adding..." : "Add Sale"}
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  )
}

export default AddSale
